import React, { useEffect, useState } from "react";
import { useBranding } from "../../context/brandingContext";
import logoCabecera from "../../assets/img/logos/Logo-PNG.png";
import logoFooter from "../../assets/img/logo-hb-blak.png";

const fallbacks = { logoCabecera, logoFooter };

const BrandLogo = ({ variant, alt, style, ...props }) => {
  const branding = useBranding();
  const [failedUrl, setFailedUrl] = useState(null);
  const [loadedSrc, setLoadedSrc] = useState(null);
  const url = branding[variant];
  const src = url && url !== failedUrl ? url : fallbacks[variant];

  useEffect(() => {
    if (!branding.isReady || !url || src !== url || loadedSrc === url) return undefined;
    const timeout = setTimeout(() => setFailedUrl(url), 5000);
    return () => clearTimeout(timeout);
  }, [branding.isReady, url, src, loadedSrc]);

  return (
    <img
      {...props}
      alt={alt}
      style={branding.isReady && loadedSrc === src ? style : { ...style, visibility: "hidden" }}
      src={src}
      onLoad={() => setLoadedSrc(src)}
      onError={() => {
        if (src === url) setFailedUrl(url);
      }}
    />
  );
};

export default BrandLogo;
